module.exports = __webpack_public_path__ + "src/assets/games/51/3.png";